import React, { useEffect, useState } from 'react';

// Import page components
import HomePage from './pages/HomePage';
import DataPage from './pages/DataPage';
import AboutUsPage from './pages/AboutUsPage';
import RelatedServicesPage from './pages/RelatedServices';
import ContactUsPage from './pages/ContactUsPage';
import NotFoundPage from './pages/NotFoundPage';

// Import reusable components
import Header from './components/Header'; // Import Header
import BackToTopButton from './components/BackToTopButton';
import Footer from './components/Footer'; // Import Footer

/**
 * Main App component that manages page navigation and overall layout.
 */
const App = () => {
  // State to track the current pathname
  const [pathname, setPathname] = useState(decodeURIComponent(window.location.pathname));
  // State to manage the visibility of the mobile menu
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Function to update the URL and trigger a re-render
  const navigateTo = (path) => {
    window.history.pushState({}, '', path);
    setPathname(path);
    setIsMobileMenuOpen(false); // Close mobile menu on navigation
    window.scrollTo(0, 0); // Scroll to top on navigation
  };

  // Add event listener for browser's back/forward buttons
  useEffect(() => {
    const handlePopState = () => {
      setPathname(decodeURIComponent(window.location.pathname));
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  // Function to render the correct page component based on the URL pathname
  const renderPage = () => {
    switch (pathname) {
      case '/about':
        return <AboutUsPage />;
      case '/services':
        return <RelatedServicesPage />;
      case '/contact':
        return <ContactUsPage />;
      case '/':
        return <HomePage navigateTo={navigateTo} />;
      case '/not-found':
        return <NotFoundPage navigateTo={navigateTo} />;
      default:

        return <DataPage pathname={`${pathname}`} />;
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-background-light font-sans text-text-dark">
      {/* Header Component */}
      <Header
        currentPage={pathname}
        navigateTo={navigateTo}
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />

      {/* Main Content Sections - Conditionally rendered */}
      <main className="container mx-auto p-4 md:p-8 flex-grow">
        {renderPage()}
      </main>

      {/* Back to Top Button */}
      <BackToTopButton />

      {/* Footer Component */}
      <Footer />
    </div>
  );
};

export default App;
